'use client'
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Row} from "react-bootstrap";
import SvgButton from "@/components/SvgButton";
import useDeviceTypeMobile from "@/components/hooks/useDeviceTypeMobile";
import parser from "html-react-parser";
import {Img} from "@/components/Img";
const PopupV1 =({
                    show,
                    handleClose,
                    no_img,
                    item,
                    title,
                    description,
                    data,
                    subtitle,
                    img, about
                }) => {
    const popupData = data;
    const menuIconB=`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8536 12.1464C12.6583 11.9512 12.3417 11.9512 12.1464 12.1464C11.9512 12.3417 11.9512 12.6583 12.1464 12.8536L19.2947 20.0018L12.1464 27.1501C11.9512 27.3454 11.9512 27.662 12.1464 27.8572C12.3417 28.0525 12.6583 28.0525 12.8536 27.8572L20.0018 20.7089L27.1501 27.8572C27.3454 28.0525 27.662 28.0525 27.8572 27.8572C28.0525 27.662 28.0525 27.3454 27.8572 27.1501L20.7089 20.0018L27.8572 12.8536C28.0525 12.6583 28.0525 12.3417 27.8572 12.1464C27.662 11.9512 27.3454 11.9512 27.1501 12.1464L20.0018 19.2947L12.8536 12.1464Z" fill="black"/>
</svg>`

    return (

        <StyledModal>
            <Modal
                show={show}
                item={item}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="gph_modal popup-version-one popup"
            >
                <div className="main_scroll">
                    <Modal.Body>
                        <Container>
                            <Row className={'for-close'}>
                                <Col md={12} className={'d-flex justify-content-between align-items-center'}>
                                    <p></p>
                                    <div onClick={handleClose} className="close-area ">
                                        <SvgButton svg={menuIconB}
                                                   width={40}
                                                   height={40}
                                        />
                                    </div>
                                </Col>

                            </Row>
                        </Container>
                        <Container>
                            <Row>
                                <div className="modal-data d-flex">
                                    <Col sm={{span: 6}} className='modal-data__content'>
                                        <div className="scroll-div">
                                            {
                                                about ?
                                                    <>
                                                        <Col md={12}>

                                                            <h3>{parser(data?.subtitle || '')}</h3><br/>

                                                            {
                                                                parser(data?.description || '')
                                                            }
                                                        </Col>
                                                    </>
:
                                                    <>

                                                        <Col md={12}>
                                                            <h5>{parser(data?.title || '')}</h5>
                                                            <p>{parser(data?.designation || '')}</p>

                                                            {
                                                                parser(data?.description || '')
                                                            }
                                                        </Col>

                                                    </>
                                            }

                                        </div>
                                    </Col>
                                    <Col sm={{span:5,offset:1}} className="modal-data__img">
                                       <div className="image-wrapper-management">
                                           <Img src={data?.image  || ''}/>
                                       </div>
                                    </Col>
                                </div>
                            </Row>
                        </Container>
                    </Modal.Body>
                </div>
            </Modal>
        </StyledModal>

    )
};


const StyledModal = styled.div`

  .modal-dialog {
    margin: 0;
  }
 
  h5{
    color: #EDEEEF !important;
  }

  .footer__social {
    .col-sm-4 {
      min-width: 100%;
      justify-content: flex-start !important;

      &:nth-of-type(1) {
        display: none;
      }
      &:nth-last-of-type(1) {
        //display: none !important;
      }
    }
  }
  
`;


export default React.memo(PopupV1);
